import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

const getAll = (keyword, page, perPage, all, active) => {
  return axios.get(process.env.REACT_APP_API_URL + "promoCodes/list", {
    headers: authHeader(),
    data: {},
    params: {
      keyword,
      page,
      perPage,
      all,
      active
    },
  });
};

const get = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `promoCodes/view/${id}`, {
    headers: authHeader(),
  });
};

const create = (data) => {
  return axios.post(process.env.REACT_APP_API_URL + `promoCodes/create`, data, {
    headers: multipartHeader(),
  });
};

const update = (id, data) => {
  return axios.put(process.env.REACT_APP_API_URL + `promoCodes/update/${id}`, data, {
    headers: multipartHeader(),
  });
};

const updateStatus = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `promoCodes/updateStatus/${id}`, data,
    {
      headers: authHeader(),
    }
  );
};

const deletePromoCode = (id, data) => {
  return axios.delete(process.env.REACT_APP_API_URL + `promoCodes/delete/${id}`, {
    headers: authHeader(),
    data,
  });
};

const restore = (id, data) => {
  return axios.get(process.env.REACT_APP_API_URL + `promoCodes/restore/${id}`, {
    headers: authHeader(),
    params: data,
  });
};

export default {
  getAll,
  get,
  create,
  update,
  updateStatus,
  deletePromoCode,
  restore
};
